import RecruitmentActivityAnalytics from './RecruitmentActivityAnalytics';

export default RecruitmentActivityAnalytics;
